import React from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import { TextField, Grid,InputLabel  } from '@material-ui/core';


const FormInput = ({name, label, required,isError}) => {

    const {control} = useFormContext();

    return (
            <Grid item xs={12} sm={6}>
            <InputLabel>{label}</InputLabel>
            <Controller
                render={({ field }) => <TextField {...field} />}
                name={name}
                control={control}
                label={label}
                fullWidth
                required={required}
                error={isError}
                variant="outlined"
                />
        </Grid>
    );
}

export default FormInput;
